export default "__VITE_ASSET__SRpsVbfn__"